/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { LogReport } from '../models/system/LogReport';

export class BaseService {
    private lastRequestUrl: string = null;
    private lastLogReport: LogReport[] = null;
    private lastGenericError: any = null;

    public getLastRequest() {
        return this.lastRequestUrl;
    }

    public getLastLogReport(): LogReport[] {
        return this.lastLogReport;
    }

    public getLastGenericError() {
        return this.lastGenericError;
    }

    public setLastRequest(url: string) {
        this.lastRequestUrl = url;
    }

    public setLastLogReport(logRep: LogReport[]) {
        this.lastLogReport = logRep;
    }

    public setLastGenericError(genError: any) {
        this.lastGenericError = genError;
    }

    public getLastErrors(): any {
        return {
            requestUrl: this.lastRequestUrl,
            logReports: this.lastLogReport,
            genericErrors: this.lastGenericError
        };
    }
}
